import { useSelector } from 'react-redux';
import { useAbility } from '../permissions/AbilityContext';

/**
 * New RBAC permission hook for cx-qm-reporting.
 * Replaces useRoles + old usePermissions.
 */
const useAbilityPermissions = () => {
  const ability = useAbility();
  const { userData } = useSelector((store) => store.authReducer);

  const can = (action, resource) => ability.can(action, resource);
  const cannot = (action, resource) => ability.cannot(action, resource);

  const isSuperAdmin = ability.can('manage', 'all');
  const organizationId = userData?.organizationId;
  const roles = userData?.roles || [];

  const hasRole = (roleName) => roles.some((r) => r.name === roleName);

  return {
    can,
    cannot,
    isSuperAdmin,
    organizationId,
    roles,
    hasRole,
    ability,
  };
};

export default useAbilityPermissions;
